<template>
  <div class="container invoice-table">
    <br>
    <h5>Планирование</h5>
    <div class="container">
      <div class="row">
        &nbsp;

        <!--                <div class="col-sm-auto">-->
        <!--                    <div class="input-group mb-3" style="max-width: 100px">-->
        <!--                        <select v-model="this_year"-->
        <!--                                @change="search"-->
        <!--                                class="form-control"-->
        <!--                                aria-label="Год"-->
        <!--                                aria-describedby="basic-addon2">-->
        <!--                            <option v-for="item in years" :value="item">{{item}}</option>-->
        <!--                        </select>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--                <div class="col-sm-auto">-->
        <!--                    <div class="input-group mb-3" style="max-width: 100px">-->
        <!--                        <select v-model="this_month"-->
        <!--                                @change="search"-->
        <!--                                class="form-control"-->
        <!--                                aria-label="Месяц"-->
        <!--                                aria-describedby="basic-addon2">-->
        <!--                            <option v-for="item in months" :value="item">{{item}}</option>-->
        <!--                        </select>-->
        <!--                    </div>-->
        <!--                </div>-->
        <div class="col-sm-auto">
          <div class="input-group mb-3" style="width: 150px">
            <select v-model="landCountryID"
                    @change="switchCountry"
                    class="form-control"
                    aria-label="Страна"
                    aria-describedby="basic-addon2">
              <option v-for="item in this.$store.getters.landCountries" :value="item.id">{{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-sm-auto">
          <div class="input-group mb-3" style="width: 150px">
            <select v-model="paymentTypeID"
                    @change="switchCountry"
                    class="form-control"
                    aria-label="Оплата"
                    aria-describedby="basic-addon2">
              <option v-for="item in this.$store.getters.paymentTypes" :value="item.id">{{ item.name }}
              </option>
            </select>
          </div>
        </div>

      </div>
    </div>

    <p v-if="message" class="float-left text-danger" style="margin-top: 8px; margin-left: 6px">
      <strong>{{ message }}</strong>
    </p>

    <div>
      <table class="table table-sm text-left">
        <thead>
        <th class="manager-td-width"></th>
        <th class="text-right invoice-table-td-small">Задания</th>
        <th class="text-right invoice-table-td-small">Магазины</th>
        <th class="text-right invoice-table-td-medium">План</th>
        <th class="text-right invoice-table-td-medium">Услуги</th>
        <th class="text-right invoice-table-td-small">План,%</th>
        <th class="text-right invoice-table-td-medium">Оборот</th>
        <!--                                <th class="text-right invoice-table-td-medium">На задание</th>-->
        <!--                                <th class="text-right invoice-table-td-medium">На магазин</th>-->
        <th class="text-right invoice-table-td-medium">Маржа</th>
        <th class="text-right invoice-table-td-small">Маржа,%</th>
        </thead>
        <tbody>
        <template v-for="(m, m_idx) in planManager">
          <tr>
            <td @click="showManagerChildren(m.item_id, m_idx)" class="cursor-pointer">{{
                m.item_name
              }}
            </td>
            <td></td>
            <td class="text-right"></td>
            <td class="text-right">{{
                new
                Intl.NumberFormat('ru-ru').format(Math.round(m.sum_customer_services_plan))
              }}
            </td>
            <td></td>
            <td></td>
            <td></td>
            <!--                        <td></td>-->
            <!--                        <td></td>-->
            <td></td>
            <td></td>
          </tr>
          <template v-if="m.show_children" v-for="(customer, customer_idx) in m.items">
            <tr class="invoice-table-tr-height">
              <td @click="showCustomerChildren(customer.item_id, m_idx, customer_idx)"
                  class="cursor-pointer vertical-align-middle td-padding-left-1">{{ customer.item_name }}
              </td>
              <td class="text-right vertical-align-middle" v-bind:title="'В: ' + customer.tasks_count + '\n' +
                            'Н: ' + customer.tasks_count_new + '\n' +
                            'Р: ' + customer.tasks_count_in_work + '\n' +
                            'П: ' + customer.tasks_count_on_approval"> {{
                  customer.tasks_count +
                  customer.tasks_count_new +
                  customer.tasks_count_in_work +
                  customer.tasks_count_on_approval
                }}
              </td>
              <td class="text-right vertical-align-middle"> {{ customer.shops_count }}
              </td>
              <td class="text-right vertical-align-middle">{{
                  new
                  Intl.NumberFormat('ru-ru').format(Math.round(customer.sum_customer_services_plan))
                }}
              </td>
              <td class="text-right vertical-align-middle" v-bind:title="'В: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(customer.sum_customer_services))) + '\n' +
                            'Н: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(customer.tasks_sum_new))) + '\n' +
                            'Р: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(customer.tasks_sum_in_work))) + '\n' +
                            'П: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(customer.tasks_sum_on_approval)))">
                {{
                  new
                  Intl.NumberFormat('ru-ru').format(Math.round(customer.sum_customer_services +
                      customer.tasks_sum_new + customer.tasks_sum_in_work +
                      customer.tasks_sum_on_approval))
                }}
              </td>
              <td></td>
              <td></td>
              <!--                            <td></td>-->
              <!--                            <td></td>-->
              <td></td>
              <td></td>
            </tr>
            <template v-if="customer.show_children" v-for="(department, department_idx) in customer.items">
              <tr class="invoice-table-tr-height">
                <td @click="showDepartmentChildren(department.item_id, m_idx, customer_idx, department_idx)"
                    class="cursor-pointer vertical-align-middle td-padding-left-2">{{
                    department.item_name
                  }}
                </td>
                <td class="text-right vertical-align-middle" v-bind:title="'В: ' + department.tasks_count + '\n' +
                            'Н: ' + department.tasks_count_new + '\n' +
                            'Р: ' + department.tasks_count_in_work + '\n' +
                            'П: ' + department.tasks_count_on_approval"> {{
                    department.tasks_count +
                    department.tasks_count_new +
                    department.tasks_count_in_work + department.tasks_count_on_approval
                  }}
                </td>
                <td class="text-right vertical-align-middle"> {{ department.shops_count }}
                </td>
                <td class="text-right vertical-align-middle">{{
                    new
                    Intl.NumberFormat('ru-ru').format(Math.round(department.sum_customer_services_plan))
                  }}
                </td>
                <td class="text-right vertical-align-middle" v-bind:title="'В: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(department.sum_customer_services))) + '\n' +
                            'Н: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(department.tasks_sum_new))) + '\n' +
                            'Р: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(department.tasks_sum_in_work))) + '\n' +
                            'П: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(department.tasks_sum_on_approval)))">
                  {{
                    new
                    Intl.NumberFormat('ru-ru').format(Math.round(department.sum_customer_services +
                        department.tasks_sum_new + department.tasks_sum_in_work +
                        department.tasks_sum_on_approval))
                  }}
                </td>
                <td></td>
                <td></td>
                <!--                            <td></td>-->
                <!--                            <td></td>-->
                <td></td>
                <td></td>
              </tr>
              <template v-if="department.show_children" v-for="(branch, branch_idx) in department.items">
                <tr class="invoice-table-tr-height">
                  <td @click="showBranchChildren(branch.item_id, m_idx, customer_idx, department_idx, branch_idx)"
                      class="cursor-pointer vertical-align-middle td-padding-left-3">{{
                      branch.item_name
                    }}
                  </td>
                  <td class="text-right vertical-align-middle" v-bind:title="'В: ' + branch.tasks_count + '\n' +
                            'Н: ' + branch.tasks_count_new + '\n' +
                            'Р: ' + branch.tasks_count_in_work + '\n' +
                            'П: ' + branch.tasks_count_on_approval"> {{
                      branch.tasks_count +
                      branch.tasks_count_new +
                      branch.tasks_count_in_work + branch.tasks_count_on_approval
                    }}
                  </td>
                  <td class="text-right vertical-align-middle"> {{ branch.shops_count }}
                  </td>
                  <td class="text-right vertical-align-middle">
                    <div v-if="!branch.editable || !branch.active" @click="branch.editable = true"
                         class="cursor-pointer">
                      <div><b>{{
                          new
                          Intl.NumberFormat('ru-ru').format(Math.round(branch.sum_customer_services_plan))
                        }} </b>
                      </div>
                    </div>
                    <div v-if="branch.editable && branch.active">
                      <input v-model="branch.sum_customer_services_plan"
                             @change="savePlan(m_idx, customer_idx, department_idx, branch_idx, branch.sum_customer_services_plan)"
                             @blur="savePlan(m_idx, customer_idx, department_idx, branch_idx, branch.sum_customer_services_plan)"
                             type="number" class="text-right table-td-input no-spin"/>
                    </div>
                  </td>
                  <td class="text-right vertical-align-middle" v-bind:title="'В: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(branch.sum_customer_services))) + '\n' +
                            'Н: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(branch.tasks_sum_new))) + '\n' +
                            'Р: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(branch.tasks_sum_in_work))) + '\n' +
                            'П: ' + (new Intl.NumberFormat('ru-ru').format(Math.round(branch.tasks_sum_on_approval)))">
                    {{
                      new
                      Intl.NumberFormat('ru-ru').format(Math.round(branch.sum_customer_services +
                          branch.tasks_sum_new + branch.tasks_sum_in_work +
                          branch.tasks_sum_on_approval))
                    }}
                  </td>
                  <td></td>
                  <td></td>
                  <!--                            <td></td>-->
                  <!--                            <td></td>-->
                  <td></td>
                  <td></td>
                </tr>
                <template v-if="branch.show_children" v-for="history in branch.items">
                  <tr>
                    <td class="td-padding-left-4">{{ history.period }}</td>
                    <td class="text-right">{{ history.tasks_count }}</td>
                    <td class="text-right">{{ history.shops_count }}</td>
                    <td class="text-right">{{
                        new
                        Intl.NumberFormat('ru-ru').format(Math.round(history.sum_customer_services_plan))
                      }}
                    </td>
                    <td class="text-right">{{
                        new
                        Intl.NumberFormat('ru-ru').format(Math.round(history.sum_customer_services))
                      }}
                    </td>
                    <td class="text-right">{{
                        new
                        Intl.NumberFormat('ru-ru', {
                          style: 'percent',
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0
                        }).format(history.plan_percent)
                      }}
                    </td>
                    <td class="text-right">{{
                        new
                        Intl.NumberFormat('ru-ru').format(Math.round(history.sum_customer))
                      }}
                    </td>
                    <!--                                <td class="text-right">{{ new-->
                    <!--                                    Intl.NumberFormat('ru-ru').format(Math.round(history.sum_customer/history.tasks_count))-->
                    <!--                                    }}-->
                    <!--                                </td>-->
                    <!--                                <td class="text-right">{{ new-->
                    <!--                                    Intl.NumberFormat('ru-ru').format(Math.round(history.sum_customer/history.shops_count))-->
                    <!--                                    }}-->
                    <!--                                </td>-->
                    <td class="text-right">{{
                        new
                        Intl.NumberFormat('ru-ru').format(Math.round(history.margin_sum))
                      }}
                    </td>
                    <td class="text-right">{{
                        new
                        Intl.NumberFormat('ru-ru', {
                          style: 'percent',
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0
                        }).format(history.margin_percent)
                      }}
                    </td>
                  </tr>
                </template>
              </template>
            </template>
          </template>

        </template>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td class="text-right font-weight-bold">{{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(this.totalPlan))
            }}
          </td>
          <td></td>
          <td></td>
          <!--                    <td></td>-->
          <!--                    <td></td>-->
          <td></td>
          <td></td>
          <td></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>
import axios from 'axios';

var d = new Date();

var year = d.getFullYear();
var month = d.getMonth();

month = month + 1;


export default {
  name: 'Plans',
  data() {
    return {
      years: [2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      year: year,
      month: month,
      tasksIt: true,
      tasksMaintenance: true,
      tasksB2B2C: true,
      tasksCleaning: true,
      subscription: true,
      countryID: "ru",
      message: "",
      paymentTypeID: 0,
      planManager: [],
    }
  },

  methods: {
    search() {

      this.message = "";
      this.planManager = [];

      if (this.landCountryID != 'Russia') {
        this.paymentTypeID = 2;
      }

      axios.get('/sales_plan', {
        params: {
          year: this.year,
          month: this.month,
          tasksIt: this.tasksIt,
          tasksMaintenance: this.tasksMaintenance,
          tasksB2B2C: this.tasksB2B2C,
          tasksCleaning: this.tasksCleaning,
          withSubscription: this.subscription,
          country_id: this.countryID,
          land_country_id: this.landCountryID,
          paymentTypeID: this.paymentTypeID,
        },
      })
          .then((res) => {
            // console.log(res.data);

            res.data.forEach(function (element) {
              element.show_children = false;
              element.items = [];
            });
            this.planManager = res.data;

          })
          .catch(error => console.log(`Error: ${error}`));
    },
    showManagerChildren(managerId, m_idx) {

      if (this.planManager[m_idx].show_children === false) {
        this.planManager[m_idx].show_children = true;

        axios.get('/sales_plan_manager', {
          params: {
            year: year,
            month: month,
            tasksIt: this.tasksIt,
            tasksMaintenance: this.tasksMaintenance,
            tasksB2B2C: this.tasksB2B2C,
            tasksCleaning: this.tasksCleaning,
            withSubscription: this.subscription,
            country_id: this.countryID,
            land_country_id: this.landCountryID,
            paymentTypeID: this.paymentTypeID,
            manager_id: managerId,
          },
        })
            .then((res) => {
              // console.log(res.data);

              res.data.forEach(function (element) {
                element.show_children = false;
                element.items = [];
                element.editable = false;

                // if (this_year === d.getFullYear() && (this_month === d.getMonth() + 1)) {
                //     console.log(d.getFullYear());
                //     console.log(this_year);
                //     console.log(d.getMonth() + 1);
                //     console.log(this_month);
                //     //element.active = true;
                // }

              });

              this.planManager[m_idx].items = res.data;


              this.planManager[m_idx].sum_customer_services_plan = 0;
              this.planManager[m_idx].items.forEach(el => {
                this.planManager[m_idx].sum_customer_services_plan += parseFloat(el.sum_customer_services_plan);
              });

            })
            .catch(error => console.log(`Error: ${error}`));
      } else {
        this.planManager[m_idx].show_children = false;
      }
    },
    showCustomerChildren(customerId, m_idx, customer_idx) {

      if (this.planManager[m_idx].items[customer_idx].show_children === false) {
        this.planManager[m_idx].items[customer_idx].show_children = true;

        axios.get('/sales_plan_customer', {
          params: {
            year: this.year,
            month: this.month,
            tasksIt: this.tasksIt,
            tasksMaintenance: this.tasksMaintenance,
            tasksB2B2C: this.tasksB2B2C,
            tasksCleaning: this.tasksCleaning,
            withSubscription: this.subscription,
            country_id: this.countryID,
            land_country_id: this.landCountryID,
            paymentTypeID: this.paymentTypeID,
            manager_id: this.planManager[m_idx].item_id,
            customer_id: customerId,
          },
        })
            .then((res) => {
              // console.log(res.data);

              res.data.forEach(function (element) {
                element.show_children = false;
                element.items = [];
              });

              this.planManager[m_idx].items[customer_idx].items = res.data;

            })
            .catch(error => console.log(`Error: ${error}`));
      } else {
        this.planManager[m_idx].items[customer_idx].show_children = false;
      }
    },

    showDepartmentChildren(departmentId, m_idx, customer_idx, department_idx) {

      if (this.planManager[m_idx].items[customer_idx].items[department_idx].show_children === false) {
        this.planManager[m_idx].items[customer_idx].items[department_idx].show_children = true;

        axios.get('/sales_plan_department', {
          params: {
            year: this.year,
            month: this.month,
            tasksIt: this.tasksIt,
            tasksMaintenance: this.tasksMaintenance,
            tasksB2B2C: this.tasksB2B2C,
            tasksCleaning: this.tasksCleaning,
            withSubscription: this.subscription,
            country_id: this.countryID,
            land_country_id: this.landCountryID,
            paymentTypeID: this.paymentTypeID,
            manager_id: this.planManager[m_idx].item_id,
            department_id: departmentId,
          },
        })
            .then((res) => {
              // console.log(res.data);

              res.data.forEach(function (element) {
                element.show_children = false;
                element.items = [];
                element.editable = false;
                // element.active = false;
                element.active = true;
              });

              this.planManager[m_idx].items[customer_idx].items[department_idx].items = res.data;

            })
            .catch(error => console.log(`Error: ${error}`));
      } else {
        this.planManager[m_idx].items[customer_idx].items[department_idx].show_children = false;
      }
    },

    showBranchChildren(branchId, m_idx, customer_idx, department_idx, branch_idx) {

      if (this.planManager[m_idx].items[customer_idx].items[department_idx].items[branch_idx].show_children === false) {
        this.planManager[m_idx].items[customer_idx].items[department_idx].items[branch_idx].show_children = true;

        axios.get('/sales_plan_branch', {
          params: {
            year: this.year,
            month: this.month,
            tasksIt: this.tasksIt,
            tasksMaintenance: this.tasksMaintenance,
            tasksB2B2C: this.tasksB2B2C,
            tasksCleaning: this.tasksCleaning,
            withSubscription: this.subscription,
            country_id: this.countryID,
            land_country_id: this.landCountryID,
            paymentTypeID: this.paymentTypeID,
            manager_id: this.planManager[m_idx].item_id,
            department_id: this.planManager[m_idx].items[customer_idx].items[department_idx].item_id,
            branch_id: branchId,
          },
        })
            .then((res) => {
              // console.log(res.data);

              res.data.forEach(function (element) {
                element.show_children = false;
                element.items = [];
              });

              this.planManager[m_idx].items[customer_idx].items[department_idx].items[branch_idx].items = res.data;

            })
            .catch(error => console.log(`Error: ${error}`));
      } else {
        this.planManager[m_idx].items[customer_idx].items[department_idx].items[branch_idx].show_children = false;
      }
    },

    savePlan(m_idx, customer_idx, department_idx, branch_idx, plan) {

      if (this.paymentTypeID == 0) {
        this.message = "Payment type is not selected"
        return;
      }

      this.planManager[m_idx].items[customer_idx].items[department_idx].items[branch_idx].editable = false;

      axios.post('/sales_plan', {
        year: year,
        month: month,
        country_id: this.countryID,
        land_country_id: this.landCountryID,
        payment_type_id: Number(this.paymentTypeID),
        customer_id: this.planManager[m_idx].items[customer_idx].item_id,
        department_id: this.planManager[m_idx].items[customer_idx].items[department_idx].item_id,
        branch_id: this.planManager[m_idx].items[customer_idx].items[department_idx].items[branch_idx].item_id,
        sum_customer_services: parseFloat(plan),
      })
          .then((res) => {
            // console.log(res.data);

            // res.data.forEach(function (element) {
            //     element.show_children = false;
            //     element.items = [];
            // });
            //
            // this.planManager[m_idx].items[customer_idx].items = res.data;

          })
          .catch(error => console.log(`Error: ${error}`));

      this.planManager[m_idx].items[customer_idx].items[department_idx].sum_customer_services_plan = 0;
      this.planManager[m_idx].items[customer_idx].items[department_idx].items.forEach(el => {
        this.planManager[m_idx].items[customer_idx].items[department_idx].sum_customer_services_plan += parseFloat(el.sum_customer_services_plan);
      });


      this.planManager[m_idx].items[customer_idx].sum_customer_services_plan = 0;
      this.planManager[m_idx].items[customer_idx].items.forEach(el => {
        this.planManager[m_idx].items[customer_idx].sum_customer_services_plan += parseFloat(el.sum_customer_services_plan);
      });

      this.planManager[m_idx].sum_customer_services_plan = 0;
      this.planManager[m_idx].items.forEach(el => {
        this.planManager[m_idx].sum_customer_services_plan += parseFloat(el.sum_customer_services_plan);
      });

    },

    switchCountry() {
      let landCountry = this.$store.getters.landCountries.find(({id}) => id === this.landCountryID);

      this.countryID = landCountry.parentCountry;

      localStorage.setItem('countryId', this.countryID);
      localStorage.setItem('landCountryID', this.landCountryID);
      localStorage.setItem('year', this.year);
      localStorage.setItem('month', this.month);
      localStorage.setItem('paymentTypeID', this.paymentTypeID);

      this.search();
    }

  },

  computed: {
    totalPlan: function () {
      return this.planManager ? this.planManager.map(el => el.sum_customer_services_plan).reduce((a, b) => a + b, 0) : 0;
    }
  }
  ,

  beforeCreate() {
    axios.defaults.headers.authorization = this.$store.state.token;
  }
  ,

  created() {
    document.title = 'Планы';

    let landCountryID = localStorage.getItem('landCountryID');
    if (landCountryID != null) {
      this.landCountryID = landCountryID
    } else {
      this.landCountryID = "Russia";
      localStorage.setItem('landCountryID', this.landCountryID);
    }

    let paymentTypeID = localStorage.getItem('paymentTypeID');
    if (paymentTypeID != null) {
      this.paymentTypeID = paymentTypeID
    } else {
      this.paymentTypeID = 0;
      localStorage.setItem('paymentTypeID', this.paymentTypeID);
    }

    let landCountry = this.$store.getters.landCountries.find(({id}) => id === this.landCountryID);
    this.countryID = landCountry.parentCountry;

    this.search();
  }
  ,

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.invoice-table {
  font-size: 14px;
}

.invoice-table-td-medium {
  width: 95px;
}

.invoice-table-td-small {
  width: 60px;
}

.table-td-input {
  width: 70px;
}

.invoice-table-tr-height {
  vertical-align: middle;
  height: 36px;
}

.vertical-align-middle {
  vertical-align: middle;
}

.manager-td-width {
  width: 150px;
}

.td-padding-left-1 {
  padding-left: 50px;
}

.td-padding-left-2 {
  padding-left: 100px;
}

.td-padding-left-3 {
  padding-left: 160px;
}

.td-padding-left-4 {
  padding-left: 230px;
}

.no-spin::-webkit-inner-spin-button, .no-spin::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
  -moz-appearance: textfield !important;
}

</style>
